/**
 * G2b/K4 — Satis Analiz iki kolon yerlesim sabitleri. Ayri modulde: `pages/SatisAnaliz.tsx` bir SAYFA
 * modulu oldugundan olmayan-bilesen disa aktarimi react-refresh `only-export-components` kuralini ihlal
 * eder (controller ruling). Hem sayfa hem test buradan aynı degeri okur.
 *
 * `min-w-0`: recharts ResponsiveContainer ebeveynden genislik okur; grid varsayilani `min-width:auto`
 * grafigi TASIRIR. `empty:hidden`: blok `null` donerse bos hucre yer kaplamaz. Esit boy zinciri: grid
 * `stretch` -> hucre (flex-col) -> blok sarmalayicisi (`div[data-testid]`, flex-1 flex-col) -> SectionCard
 * `section` (flex-1). Zincirin bir halkasi eksikse kisa kart komsusunun boyuna uzamaz.
 */
export const HUCRE =
  'min-w-0 empty:hidden flex flex-col [&>div]:flex-1 [&>div]:flex [&>div]:flex-col [&>div>section]:flex-1';
